function defaultToggleNavigation(){

	(function($) {
		$('.nav-icon-toggle').on('click', function() {
		    $(this).toggleClass('open');
		});

		/* ---------------------------------------------- /*
		 * Collapse navbar on click
		/* ---------------------------------------------- */

		$(document).on('click', '.main-nav.in', function(e) {
		    if ($(e.target).is('a') && !$(e.target).parent().hasClass('has-submenu')) {
		        $(this).collapse('hide');
		        $('.nav-icon-toggle').toggleClass('open');
		    }
		});

	})( jQuery );
}
